module.exports = __webpack_public_path__ + "img/logo.6bb4802c.png";